<template>
	<div :class="classNames+'_content'" v-if="dialogVisibe" v-clickoutside='closeFastReplyCard'>
		<div :class="classNames+'_title'">
			快捷回复
		</div>
		<div :class="classNames+'_main'">
			<div :class="classNames+'_headerbar'">
				 <el-button :type="activeIndex == -1 ? 'primary' : ''" @click="getGroupInfo({id: ''},-1)">全部分组</el-button>
				 <el-button :type="activeIndex == index ? 'primary' : ''" v-for="(item,index) of groupListData" :key="item.id" @click="getGroupInfo(item,index)">{{item.name}}</el-button>
			</div>
			<div :class="classNames+'_searchbar'">
				 <el-input placeholder="请输入标题" v-model="searchFormObj.title" class="input-with-select">
				    <el-button slot="append" icon="el-icon-search" @click="getReplyList()"></el-button>
				  </el-input>
			</div
			<div :class="classNames+'_body'">
				<ul :class="classNames+'_list-wp'">
					<li :class="classNames+'_list-item'" v-for="(item,index) of replyListData.data" :key="item.id">
						<div :class="classNames+'_list-word'">{{item.content}} <span v-if="item.type == 2" :class="classNames+'_alink'" @click.stop="openLinkFun(item)">
							{{item.link_title}}
						</span>
						</div>
						<div :class="classNames+'_list-btn'" @click.stop="sendCardInfo(item,index)">
							<img class="send-icon-default" src="http://img-dbzd.doubaozhidao.com/20230516/1684230423382335.png" alt="发送">
							<img class="send-icon-active" src="http://img-dbzd.doubaozhidao.com/20230516/1684230489405950.png" alt="发送" >发送</div>
					</li>
				</ul>
				<div :class="classNames+ '_reply-card-pagin'">
					 <Pagination @change="changeSize" :total="replyListData.total" ref="pagination" v-model="searchFormObj.page" v-if="Math.ceil(replyListData.total / searchFormObj.limit) > 1"></Pagination>
					 
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import clickoutside from 'element-ui/src/utils/clickoutside'
import Pagination from '@/components/pagination/pagination.vue'
export default {
	props: {
		value: {
		    type: Boolean,
		    default: false
		},
	},
	directives:{
		clickoutside
	},
	data() {
		return {
            classNames: "fastReplyCard",
			activeIndex: -1,
			searchFormObj: {
				group_id: '',
				page: 1,
				limit: 10,
				title: '',
				is_show: ''
			},
			groupListData: [],
			replyListData: {
				total: 0,
				data: []
			}
			
		}
	},
	computed: {
		dialogVisibe: {
			get() {
				return this.value
			},
			set(news) {
				this.$emit("input",news);
			}
		}
	},
	created() {
		this.getGroupList()
		this.getReplyList()
	},
	methods: {
		...mapActions('dymessage', ['groupList','replyList']),
		async getGroupList() {
			let res = await this.groupList()
			this.groupListData = res.data
		},
		getGroupInfo(data,index){
			this.activeIndex = index
			this.searchFormObj.group_id = data.id
			this.searchFormObj.page = 1
			this.getReplyList()
		},
		async getReplyList(){
			const params = Object.assign({},this.searchFormObj)
			let res = await this.replyList(params)
			this.replyListData =  {total: res.count,data: res.list}
		},
		changeSize(size) {
		    this.searchFormObj.page = size
		    this.getReplyList()
		},
		sendCardInfo(item,index){
			this.$emit('sendInfo',item)
		},
		closeFastReplyCard(){
			this.$emit("input",false);
		},
		openLinkFun(data){
			window.open(data.link_url)
		},
	}
}
</script>
<style lang="less">
    @classNames: fastReplyCard;
	.@{classNames}_content{
		margin-top: 10px;
		padding: 10px;
		background-color: #818181;
		width: 360px;
		height: calc(100% - 10px);
		box-sizing: border-box;
	}
	.@{classNames}_title{
		height: 30px;
		color: #fff;
		font-size: 14px;
	}
	.@{classNames}_headerbar{
		text-align: center;
		white-space: nowrap;
		overflow-x: scroll;
		overflow-y: hidden;
		padding:0 10px 10px 10px;
		margin-bottom: 10px;
	}
	.@{classNames}_main{
		padding: 10px;
		height: calc(100% - 60px);
		background-color: #fff;
		
	}
	.@{classNames}_body{
	
	}
	.@{classNames}_list-wp{
		padding: 4px;
		color: #222;
		font-size: 14px;
		list-style: none;
		max-height: 400px;
		overflow-y: auto;
		.@{classNames}_list-item{
			padding:10px;
			list-style: none;
			&:hover{
				background: #f5f5f5;
			}
		}
		.@{classNames}_list-word{
			border-bottom: 1px solid #e5e5e5;
			padding-bottom: 10px;
		}
		.@{classNames}_list-btn{
			cursor: pointer;
			padding-top: 10px;
			text-align: right;
			display: flex;
			justify-content: right;
			align-items: center;
			img{
				width: 40px;
			}
			.send-icon-active{
				display: none;
			}
			&:hover{
				.send-icon-default{
					display: none;
				}
				.send-icon-active{
					display: inline-block;
				}
			}
		}
	}
	.@{classNames}_alink{
		margin-right: 12px;
		color: #1989FA;
		font-size: 14px;
		cursor: pointer;
	}
</style>

 